import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får jag använda lagboken på kunskapsprovet?";
const SHORT_ANSWER = "Nej. Kunskapsprovet är ett slutet prov utan hjälpmedel – ingen lagbok, ingen mobil, ingen anteckning.";

export const Route = createFileRoute("/fraga/far-jag-anvanda-lagboken")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får jag använda lagboken på kunskapsprovet" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Provet görs i kommunens lokaler under övervakning. Du får oftast bara penna och papper för uträkningar (om provet innehåller mängdfrågor). Detta gör förberedelse via övningsfrågor särskilt viktig."}
      source={{ label: "Folkhälsomyndigheten – Kunskapsprov", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/kunskapsprov/" }}
      extraSources={[]}
      deepGuide={{ to: "/kunskapsprov-alkohollagen", label: "Kunskapsprovet – så är det upplagt" }}
      related={[{"to": "/fraga/kostar-kunskapsprovet-extra", "label": "Kostar kunskapsprovet extra utöver ansökan?"}, {"to": "/fraga/hur-manga-forsok-har-jag", "label": "Hur många försök har jag på kunskapsprovet?"}, {"to": "/fraga/hur-lang-tid-tar-provet", "label": "Hur lång tid har jag på mig på kunskapsprovet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får jag använda lagboken på kunskapsprovet?" },
      { name: "description", content: "Nej. Kunskapsprovet är ett slutet prov utan hjälpmedel – ingen lagbok, ingen mobil, ingen anteckning." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-jag-anvanda-lagboken" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-jag-anvanda-lagboken" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-jag-anvanda-lagboken",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får jag använda lagboken på kunskapsprovet", url: "https://alkoholprovet.se/fraga/far-jag-anvanda-lagboken" },
      ]),
    ],
  }),
});
